import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/lib/supabase";
import { useAuth } from "./useAuth";
import type { ReferralRow } from "@/types/database";

export function useReferrals() {
  const { user } = useAuth();
  return useQuery({
    queryKey: ["referrals", user?.id],
    enabled: !!user?.id,
    queryFn: async (): Promise<ReferralRow[]> => {
      const { data, error } = await supabase
        .from("referrals")
        .select("*")
        .eq("referrer_id", user!.id)
        .order("created_at", { ascending: false });
      if (error) throw error;
      return data ?? [];
    },
  });
}

export interface ReferralStats {
  /** Filleuls inscrits avec ton code (qu'ils aient payé ou non) */
  total: number;
  /** Filleuls qui ont souscrit un plan */
  paid: number;
  isLoading: boolean;
}

/**
 * Stats de parrainage calculées depuis la table `referrals` — source unique
 * de vérité, contrairement au champ dénormalisé `users.paid_referrals_count`
 * qui peut être désynchronisé.
 */
export function useReferralStats(): ReferralStats {
  const q = useReferrals();
  const rows = q.data ?? [];
  return {
    total: rows.length,
    paid: rows.filter((r) => r.has_paid).length,
    isLoading: q.isLoading,
  };
}
